import React from "react";
import { Link } from "react-router-dom";
import { FiSearch, FiBarChart2, FiLink, FiTrendingUp, FiCompass, FiFileText, FiEdit2, FiArrowRight, FiArrowRightCircle } from "react-icons/fi";
import "./GrowthTools.css";

const growthTools = [
  { name: "Website Audit", description: "Find and fix SEO issues on your website.", icon: FiSearch, color: "blue", path: "/seo-inspector" },
  { name: "DA PA Checker", description: "Check Domain & Page Authority instantly.", icon: FiBarChart2, color: "purple", path: "/da-pa-checker" },
  { name: "Keyword Research", description: "Discover high-value keywords with real data.", icon: FiLink, color: "green", path: "/best-keyword-research-tool" },
  { name: "Backlink Checker", description: "Analyze and monitor your backlinks.", icon: FiLink, color: "orange", path: "/backlink-checker" },
  { name: "Rank Tracker", description: "Track your keyword rankings daily.", icon: FiTrendingUp, color: "red", path: "/keyword-position-tracker" },
  { name: "Site Explorer", description: "Explore any domain in detail.", icon: FiCompass, color: "cyan", path: "/competitive-research-with-seobix-understand-your-competitors-strategies" },
  { name: "SERP Checker", description: "Analyze search results and features.", icon: FiFileText, color: "amber", path: "/serp-simulator" },
  { name: "Content Optimizer", description: "Create SEO-friendly content that ranks.", icon: FiEdit2, color: "violet", path: "/content-quality-checker" },
];

export default function GrowthTools() {
  return (
    <section className="home-section growth-tools pb-5" aria-labelledby="growth-tools-heading">
      <div className="home-content">
        <header className="growth-tools-header">
          <span className="growth-tools-eyebrow">EXPLORE OUR TOOLS</span>
          <h2 id="growth-tools-heading">Powerful Tools for Your <span>Growth</span></h2>
          <div className="growth-tools-intro">
            <p>Everything you need to improve your search visibility, analyze competitors and grow your business.</p>
            <a href="https://dashboard.seobix.com/" className="growth-tools-all">View All Tools <FiArrowRight aria-hidden="true" /></a>
          </div>
        </header>
        <div className="growth-tools-grid">
          {growthTools.map(({ name, description, icon: Icon, color, path }) => (
            <Link className="growth-tool-card" to={path} key={name}>
              <span className={`growth-tool-icon growth-tool-icon-${color}`}><Icon aria-hidden="true" /></span>
              <div className="growth-tool-copy"><h3>{name}</h3><p>{description}</p></div>
              <FiArrowRightCircle className="growth-tool-arrow" aria-hidden="true" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
